export default __webpack_public_path__ + "static/media/01.c12589c8.jpg";